import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// UI
import Typography from '@material-ui/core/Typography';
import ErrorFaceIcon from 'components/Icons/ErrorFace';

// Style
import { withStyles } from '@material-ui/core/styles';

const styles = theme => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
    },
    icon: {
      width: 300,
      height: 200,
    },
    copy: {
      textAlign: 'center',
    },
  };
};

class ErrorView extends PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    title: PropTypes.node,
    body: PropTypes.node,
    className: PropTypes.object,
  };

  defaultCopy = {
    title: 'Yikes, an error occurred.',
    body: (
      <React.Fragment>
        Try reloading the page, if the
        <br />
        issue persists then please contact us.
      </React.Fragment>
    ),
  };

  render() {
    let { classes, className, title, body } = this.props;

    return (
      <div className={classnames(classes.root, className)} data-testid="loader-error">
        <ErrorFaceIcon className={classes.icon} />
        <Typography className={classes.copy} variant="h6">
          {title || this.defaultCopy.title}
        </Typography>
        <Typography className={classes.copy} variant="body1">
          {body || this.defaultCopy.body}
        </Typography>
      </div>
    );
  }
}

export default withStyles(styles)(ErrorView);
